export const ContactReasonType = {
  fi: [
    {
      value: 'valiseinarangat',
      title: 'Väliseinärangat',
    },
    {
      value: 'koolarihtl',
      title: 'KOOLARI hattulistat',
    },
    {
      value: 'alakatot',
      title: 'Alakatot',
    },
    {
      value: 'termorangat',
      title: 'Termorangat',
    },
    {
      value: 'kevytorret',
      title: 'Kevytorret',
    },
    {
      value: 'korotuslattiat',
      title: 'KOOLARI asennuslattia',
    },
    {
      value: 'moduulit',
      title: 'Moduulit',
    },
    {
      value: 'liune',
      title: 'Liune-ovet',
    },
  ],
  en: [
    {
      value: 'palaute',
      title: 'Feedback',
    },
    {
      value: 'tiedustelu',
      title: 'Enquiry',
    },
    {
      value: 'tarjouspyyntö',
      title: 'Offer request',
    },
  ],
  se: [
    {
      value: 'palaute',
      title: 'Respons',
    },
    {
      value: 'tiedustelu',
      title: 'Förfrågan',
    },
    {
      value: 'tarjouspyyntö',
      title: 'Offertförfrågan',
    },
  ],
};

export const FeedbackReason = {
  fi: [
    {
      value: 'tarjouspyynto',
      title: 'Tarjouspyyntö',
    },
    {
      value: 'avainasiakasrekisterointi',
      title: 'Avainasiakasrekisteröinti',
    },
    {
      value: 'palaute',
      title: 'Palaute',
    },
  ],
  en: [
    {
      value: 'avainasiakasrekisterointi',
      title: 'Register as key customer',
    },
    {
      value: 'yhteydenotto',
      title: 'Contacting',
    },
  ],

  se: [
    {
      value: 'avainasiakasrekisterointi',
      title: 'Nyckelkundsregistrering',
    },
    {
      value: 'yhteydenotto',
      title: 'Kontakt',
    },
  ],
};
